namespace GeniuzPOS.InitialData {
    export class PsPosTouchPanelTypeColumns {
        static columnsKey = 'InitialData.PsPosTouchPanelType';
    }
}
